import React from 'react'
import styled from 'styled-components'
import tw from 'tailwind.macro'
import { Parallax } from 'react-spring/renderprops-addons.cjs'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLinkedin, faGithub } from '@fortawesome/free-brands-svg-icons'
// Components
import Layout from '../components/Layout'
import ProjectCard from '../components/ProjectCard'
import IconWrapper from '../components/IconWrapper'

// Elements
import Inner from '../elements/Inner'
import { Title, BigTitle, Subtitle } from '../elements/Titles'

// Views
import Hero from '../views/Hero'
import Projects from '../views/Projects'
import About from '../views/About'
import Contact from '../views/Contact'

import avatar from '../images/avatar.jpg'

const ProjectsWrapper = styled.div`
  ${tw`flex flex-wrap justify-between mt-8`};
  display: grid;
  grid-gap: 4rem;
  grid-template-columns: repeat(2, 1fr);
  @media (max-width: 1200px) {
    grid-gap: 3rem;
  }
  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    grid-gap: 2rem;
  }
`

const AboutHero = styled.div`
  ${tw`flex flex-col lg:flex-row items-center mt-8`};
`

const Avatar = styled.img`
  ${tw`rounded-full w-32 xl:w-48 shadow-lg h-auto`};
`

const AboutSub = styled.span`
  ${tw`text-white pt-12 lg:pt-0 lg:pl-12 text-2xl lg:text-3xl xl:text-4xl`};
`

const AboutDesc = styled.p`
  ${tw`text-grey-light text-lg md:text-xl lg:text-2xl font-sans pt-6 md:pt-12 text-justify`};
`

const ContactText = styled.p`
  ${tw`text-grey-light font-sans text-xl md:text-2xl lg:text-3xl`};
`

const Footer = styled.footer`
  ${tw`text-center text-grey absolute pin-b p-6 font-sans text-md lg:text-lg`};
`

const Index = () => (
  <>
    <Layout />
    <Parallax pages={5}>
      <Hero offset={0}>
        <BigTitle>
          Hola, <br /> Soy Juan Castellano.
        </BigTitle>
        <Subtitle>
          Un desarrollador web que crea experiencias increíbles para la próxima generación de clientes.
        </Subtitle>
      </Hero>
      <Projects offset={1}>
        <Title>Proyectos</Title>
        <IconWrapper></IconWrapper>
        <ProjectsWrapper>
          <ProjectCard
            title="Gender Classifier"
            link="https://github.com/juancastellano115/gender-classifier"
            bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)"
          >
            Un algoritmo de clasificación de género en deep learning entrenado localmente dentro de una aplicación web
            SPA.
          </ProjectCard>
          <ProjectCard
            title="Urbanos Guadalajara"
            link="https://play.google.com/store/apps/details?id=com.juancastellano.appbuses&gl=ES"
            bg="linear-gradient(to right, #662D8C 0%, #ED1E79 100%)"
          >
            Aplicación móvil hecha en Flutter y Dart para ver los autobuses de Guadalajara y Renfe en tiempo real.
          </ProjectCard>
          <ProjectCard
            title="ChromeTab"
            link="https://github.com/juancastellano115/React-chrometab"
            bg="linear-gradient(to right, #7F7FD5 0%, #91EAE4 100%)"
          >
            Página de bienvenida de Chrome que muestra la hora y el tiempo de manera bonita y sencilla.
          </ProjectCard>
          <ProjectCard
            title="Fid!"
            link="https://github.com/juancastellano115/fid-server"
            bg="linear-gradient(to right, #2884bd 0%, #55e0c5 100%)"
          >
            Fid! Es una red social Open Source de compraventa de comida casera hecha en el MEVN Stack (Mongo, Express,
            Nuxt y Node).
          </ProjectCard>
        </ProjectsWrapper>
      </Projects>
      <About offset={3}>
        <Title>Sobre mí</Title>
        <AboutHero>
          <Avatar src={avatar} alt="John Doe" />
          <AboutSub>
            Mi historia en el desarrollo y la programación comienza desde que era pequeño, movido siempre por una gran
            curiosidad por ver como funcionan las cosas y lo que hay detrás de ellas. Lo que me hizo interesarme por los
            ordenadores. Esas máquinas que usamos todos los días pero de las que realmente desconocemos su modo de
            funcionamiento.
          </AboutSub>
        </AboutHero>
        <AboutDesc>
          Y fue así como me pregunté: ¿Y cómo funciona Netflix? ¿Y cómo se hacen las aplicaciones del móvil? Esa
          curiosidad me llevó a indagar y a los quince años empecé a hacer mi primera página en HTML y CSS. A partir de
          esto aprendí Python para realizar tareas de automatización sencillas (como cambiar nombres de archivos en un
          directorio o pequeños programas útiles que se me iban ocurriendo). Fue ahí cuando decidí que, efectivamente,
          era esto a lo que me quería dedicar y donde empecé a ver el gran mundo que es la informática y la tecnología.
        </AboutDesc>
      </About>
      <Contact offset={4}>
        <Inner>
          <Title>Contacto</Title>
          <ContactText>
            <a href="mailto:juancastellano115@gmail.com">Escríbeme</a> o encuéntrame en{' '}
            <a href="https://www.linkedin.com/in/juancastellano115/">
              <FontAwesomeIcon icon={faLinkedin} style={{ marginRight: '0.5rem' }} />
              LinkedIn
            </a>{' '}
          </ContactText>
        </Inner>
        <Footer>
          &copy; 2020 Juan Castellano.{' '}
          <a href="https://github.com/juancastellano115">
            <FontAwesomeIcon icon={faGithub} style={{ marginRight: '0.3rem' }} />
            Github
          </a>
          .
        </Footer>
      </Contact>
    </Parallax>
  </>
)

export default Index
